module.exports = __webpack_public_path__ + "img/ic_mpe_time20_press.99c0813f.png";